function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDisableNotification = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 111,
  height: 111
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 784"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 783"
}, /*#__PURE__*/React.createElement("path", {
  d: "M55.5 0A55.5 55.5 0 1 1 0 55.5 55.5 55.5 0 0 1 55.5 0",
  "data-name": "Path 1681",
  style: {
    fill: "rgba(251,149,0,.24)"
  }
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Icon ionic-md-notifications-off"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.424 37.044a7.37 7.37 0 0 0 7.34-7.372h-14.68a7.37 7.37 0 0 0 7.34 7.372",
  "data-name": "Path 1749",
  style: {
    fill: "#fff"
  },
  transform: "translate(32.786 55.514)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m15.305 11.044.009.013-5.848-5.834L5.2 9.489l11.161 11.177a23.8 23.8 0 0 0-2.84 11.244v20.275l-7.256 7.372v3.667h52.7l6.4 6.43 4.262-4.3-2.142-2.129h.056z",
  "data-name": "Path 1750",
  style: {
    fill: "#fff"
  },
  transform: "translate(17.797 18.423)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.653 34.71a23.96 23.96 0 0 0-18.406-23.223v-2.58a5.487 5.487 0 1 0-10.973 0v2.58a23.3 23.3 0 0 0-7.389 3.126L49.653 51.4z",
  "data-name": "Path 1751",
  style: {
    fill: "#fff"
  },
  transform: "translate(29.45 15.623)"
}))));
export { SvgDisableNotification as ReactComponent };
export default __webpack_public_path__ + "images/disable_notification.b4a5546e.svg";